export const HEADERS = {
    partner_name : 'Partner Name',
    partner_Code : 'Partner Code',
    pincode:'Pincode',
    pan_no:'PAN No.',
    created_on:'Created On',
    created_by:'Created By',
    updated_on:'Modified On',
    updated_by:'Modified By',
    partner_type:'Vendor Type',
    action_buttons:'Edit/Delete'
}

export const TITLES = {
    basicDetails: "Basic Details",
    financialDetails: "Financial Details",
}

export const create_edit_form = {
    partner_code : {
        title:"Partner Code",
        placeholder:"Type Code"
    },
    partner_company_name : {
        title:"Partner Company Name",
        placeholder:"Type Name"
    },
    contact_person_name : {
        title:"Contact Person Name",
        placeholder:"Enter Contact Person Name"
    },
    contact_person_no : {
        title:"Contact Person Number",
        placeholder:"Enter Contact Person Number"
    },
    partner_address : {
        title:"Partner Address",
        placeholder:"Enter Address"
    },
    pincode : {
        title:"Pincode",
        placeholder:"Enter Pincode"
    },
    partner_mobile : {
        title:"Partner Mobile No",
        placeholder:"Enter Mobile No"
    },
    partner_city : {
        title:"Partner City",
        placeholder:"Enter City Name"
    },
    pan_no : {
        title:"PAN Number",
        placeholder:"Enter PAN"
    },
    partner_type : {
        title:"Vendor Type",
        placeholder:'Please select Vendor Type'
    },
    buttons:{
        submit : "Submit"
    },
    is_tds_exempted : {
        title:"Is TDS Exempted?"
    },
    tds_exemption_certificate: {
        title:"TDS Exemption Certificate",
        err_messages: {
            rquired: "TDS Exemption Certificate is required"
        }
    },
    tds_exemption_start_date: {
        title:"TDS Exemption Start Date",
        err_messages: {
            rquired: "Enter Valid Date"
        }
    },
    tds_exemption_end_date: {
        title:"TDS Exemption End Date",
        err_messages: {
            required: "TDS Exemption End Date is required"
        }
    },
    is_it_returns_filed : {
        title:"Is IT Returns Filed?"
    },
    it_returns_file: {
        title:"IT Returns File",
        err_messages: {
            required: "IT Returns File is required"
        }
    },
    it_returns_start_date: {
        title:"IT Returns Start Date",
        err_messages: {
            required: "Enter Valid Date"
        }
    },
    it_returns_end_date: {
        title:"IT Returns End Date",
        err_messages: {
            required: "IT Returns End Date is required"
        }
    },
}

export const vendor_branch = {
    fields: {
        branch : {
            title : "Branch",
            placeholder:"Enter Branch Name"
        },
        state:{
            title:"State",
            placeholder:"Select State"
        },
        city:{
            title:"City",
            placeholder:"Select City"
        },
        pincode:{
            title:"Pincode",
            placeholder:"Enter Pincode"
        },
        pan_no:{
            title:"PAN Number",
            placeholder:"Enter PAN Number"
        },
        address:{
            title:"Address",
            placeholder:"Enter Address."
        },
        is_gst_applicable :{
            title:"Is GST Applicable?"
        },
        gst_no:{
            title:"GST Number",
            placeholder:"Enter GST Number"
        },
        charge_mechanism:{
            title:"Charge Mechanism",
            placeholder:"Select Charge Mechanism"
        },
        start_date:{
            title:"Validity Start Date"
        },
        end_date:{
            title:"Validity End Date"
        },
        bank_name:{
            title:"Bank Name",
            placeholder:"Enter Bank Name"
        },
        account_holder:{
            title:"Account Holder Name",
            placeholder:"Enter Account Holder Name"
        },
        account_no:{
            title:"Account Number",
            placeholder:"Enter Account Number"
        },
        ifsc:{
            title:"IFSC Code",
            placeholder:"Enter IFSC Code"
        }
    },
    headers: {
        branch : "Branch",
        state: "State",
        city: "City",
        pincode: "Pincode",
        pan_no: "PAN Number",
        address: "Address",
        is_gst_applicable : "Is GST Applicable",
        gst_no: "GST Number",
        charge_mechanism: "Charge Mechanism",
        start_date: "Validity Start Date",
        end_date: "Validity End Date",
        bank_name: "Bank Name",
        account_holder: "Account Holder Name",
        account_no: "Account Number",
        ifsc: "IFSC Code",
        more_details: "More Details",
        edit: "Edit",
        delete: "Delete",
        vendor:"Vendor",
        vendor_branch: "Vendor Branch"
    },
    titles:{
        add_title : "Add Branch Details",
        edit_title: "Edit Branch Details",
        gst_title : "GST Details",
        bank_title : "Bank Details",
        branch_details : "Branch Details"
    },
    buttons : {
        cancel : "Cancel",
        submit: "Submit",
        ok:"Ok",
        new : "New"
    }
}

export const vendor_vehicle = {
    fields : {
        vehicle_no : {
        title : "Vehicle Number",
        placeholder : "Enter Vehicle Number"
        },
        vehicle_type :{ 
            title:"Vehicle Type",
            placeholder:"Select Vehicle Type"
        },
        ownership_type : {
            title :"Vehicle Ownership Type",
            placeholder:"Select Vehicle Ownership Type"
        },
        tracking_type:{
            title : "Preferred Tracking Type",
            placeholder:"Select Preferred Tracking Type"
        },
        gps_partner : {
            title : "GPS Partner",
            placeholder : "Enter GPS Partner"
        },
        base_location:{
            title:"Base Location",
            placeholder:"Enter Base Location"
        },
        vehicle_dimension : {
            title : "Vehicle Dimension",
            placeholder : "Enter Vehicle Dimension"
        },
        load_capacity : {
            title : "Vehicle Load Capacity",
            placeholder : "Enter Vehicle Load Capacity"
        },
        puc : {
            title : "PUC",
            placeholder : "PUC"
        },
        insurance : {
            title : "Insurance"
        },
        permit : {
            title : "Permit"
        },
        fitness : {
            title : "Fitness Certificate"
        },
        rc_number : {
            title : "Vehicle RC Number"
        },
        road_tax : {
            title : "Road Tax Validity"
        }
    },
    titles : {
        vehicle_details : "Vehicle Details",
        add_title : "Add Vehicle Details"
    },
    headers : {
        vehicle_no : "Vehicle Number",
        vehicle_type : "Vehicle Type",
        ownership_type : "Vehicle Ownership Type",
        tracking_type: "Preferred Tracking Type",
        gps_partner :  "GPS Partner",
        base_location: "Base Location",
        vehicle_dimension : "Vehicle Dimension",
        load_capacity : "Vehicle Load Capacity",
        puc :  "PUC",
        insurance : "Insurance",
        permit : "Permit",
        fitness : "Fitness Certificate",
        rc_number : "Vehicle RC Number",
        road_tax :  "Road Tax Validity",
        more : "More Details"
    },
    buttons : {
        cancel : "Cancel",
        submit: "Submit",
        ok:"Ok",
        new : "New"
    }
}